import * as React from "react";
import { IconProps } from "./types";

export const ArrowNarrowUpIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M12 20V4M12 4L6 10M12 4L18 10"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          stroke={color}
        />
      </svg>
    );
  },
);
(ArrowNarrowUpIcon as React.FunctionComponent).displayName =
  "ArrowNarrowUpIcon";

export default ArrowNarrowUpIcon;
